import { FunctionComponent } from 'react';
import { useLocation, matchPath, Link } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { IAppNavigationProps } from './AppNavigation.interface';

export const AppNavigation: FunctionComponent<IAppNavigationProps> = (props) => {
  const { navigation } = props;

  const { pathname } = useLocation();

  const matchedRouteIndex = navigation.findIndex(({ href }) => {
    const possibleMatch = matchPath(`${href}/*`, pathname);

    return possibleMatch !== null;
  });

  const currentTab = matchedRouteIndex >= 0 ? matchedRouteIndex : false;

  return (
    <Tabs value={currentTab} component={'nav'}>
      {navigation.map(({ href, title }) => (
        <Tab
          key={href}
          label={title}
          component={Link}
          to={href}
        />
      ))}
    </Tabs>
  );
};
